// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"2yTwi":[function(require,module,exports,__globalThis) {
var _indexCss = require("./index.css");
var _searchResultsCss = require("./searchResults.css");
var _resultCardUtil = require("./utils/resultCard.util");
var _formUtils = require("./utils/form.utils");
var _apiUtils = require("./utils/api.utils");
var _urlParamsUtils = require("./utils/urlParams.utils");
var _domUtil = require("./utils/dom.util");
const SELECTOR_LIST = ".pls2__search-results__list";
const SELECTOR_TEMPLATE = "template";
const SELECTOR_BUTTON_VIEW = ".pls2__search-results__button-view";
const SELECTOR_LOADER = ".pls2__search-results__loader";
const SELECTOR_BUTTON_LOAD_MORE = "[data-item='button-load-more']";
const SELECTOR_FORM_DETAIL = "[data-item='form-detail']";
const SELECTOR_FORM_NO_RESULTS = "[data-item='form-no-results']";
const SELECTOR_FORM_LOAD_MORE = "[data-item='form-load-more']";
class SearchResults {
    constructor(el){
        this.el = el;
        this.resultCardService = new (0, _resultCardUtil.ResultCardService)();
        this.resultsPerPage = parseInt(this.el.dataset.resultsPerPage);
        this.maxResults = parseInt(this.el.dataset.maxResults);
        this.apiService = new (0, _apiUtils.ApiService)({
            resultsPerPage: this.resultsPerPage,
            maxResults: this.maxResults
        });
        this.btnLoadMore = this.el.querySelector(SELECTOR_BUTTON_LOAD_MORE);
        this.loaderEl = this.el.querySelector(SELECTOR_LOADER);
        this.listElement = this.el.querySelector(SELECTOR_LIST);
        this.templateEl = this.el.querySelector(SELECTOR_TEMPLATE);
        this.formDetail = new (0, _formUtils.FormService)(this.el.querySelector(SELECTOR_FORM_DETAIL));
        this.formNoResults = new (0, _formUtils.FormService)(this.el.querySelector(SELECTOR_FORM_NO_RESULTS));
        this.formLoadMore = new (0, _formUtils.FormService)(this.el.querySelector(SELECTOR_FORM_LOAD_MORE));
        this.fetchData();
    }
    checkSearchBarForPrefill() {
        const searchBar = document.querySelector(".xchange-public-leasing-search-bar");
        if (!searchBar) return;
        const prefillLocation = searchBar.getAttribute("data-prefill-pickup");
        const prefillAction = searchBar.getAttribute("data-prefill-action");
        return {
            prefillLocation,
            prefillAction
        };
    }
    async fetchData() {
        const urlParams = (0, _urlParamsUtils.parseUrlParams)();
        const showDefaults = this.el.getAttribute("data-show-defaults");
        if (showDefaults) {
            const prefillData = this.checkSearchBarForPrefill();
            const isUserInitiatedSearch = (0, _urlParamsUtils.getUrlParam)("pickUpLocationUnlocode");
            if (prefillData && !isUserInitiatedSearch) {
                prefillData.prefillLocation && urlParams.pickUpLocationUnlocode?.push(prefillData.prefillLocation);
                if (prefillData.prefillAction) prefillData.prefillAction === "supply" ? urlParams.direction = "Supplying" : urlParams.direction = "Using";
            }
        }
        if (urlParams.pickUpLocationUnlocode?.length === 0 && urlParams.dropOffLocationUnlocode?.length === 0) {
            this.setLoading(false);
            return;
        }
        this.apiService.createSearchParams(urlParams);
        try {
            this.setLoading(true);
            // this.setLoading(false);
            // this.setTotalResults(results.totalElements);
            // No Results, show no results message and return early
            // if (results.content.length === 0 && results.empty) {
            //   this.noResultsEl.classList.add("-visible");
            //   this.setLoadMore(0, 0);
            //   return;
            // }
            const data = await this.apiService.getResults();
            this.setLoading(false);
            if (data.searchResults.length === 0) {
                this.formNoResults.show();
                return;
            }
            this.appendToResults(data);
            this.setLoadMore({
                pickupLocationName: urlParams.pickUpLocationUnlocode?.[0],
                dropOffLocationName: urlParams.dropOffLocationUnlocode?.[0],
                direction: urlParams.direction
            });
        } catch (error) {
            console.error(error);
        }
    }
    appendToResults(data) {
        data.searchResults.forEach((searchResult)=>{
            const clone = this.templateEl.content.cloneNode(true);
            const buttonFormView = clone.querySelector(SELECTOR_BUTTON_VIEW);
            if (buttonFormView) buttonFormView.addEventListener("click", ()=>{
                this.formDetail.show(searchResult);
            });
            this.hydrateResultCard(searchResult, clone);
            this.listElement.appendChild(clone);
        });
    }
    setLoadMore(data) {
        this.btnLoadMore.addEventListener("click", ()=>this.formLoadMore.show(data));
        this.btnLoadMore.setAttribute("data-show", "true");
    }
    hydrateResultCard(result, template) {
        const variablesToHydrate = {
            equipmentCount: {},
            equipmentType: {},
            perDiem: {
                transformFunc: this.resultCardService.getCurrencyFormat
            },
            pickupLocationName: {
                tag: "location-pickup"
            },
            dropOffLocationName: {
                tag: "location-dropoff"
            },
            whoPays: {
                transformFunc: this.resultCardService.getPayee
            },
            averageRating: {
                rating: true,
                transformFunc: (rating)=>rating.toFixed(1)
            },
            freeDays: {},
            pickupCharge: {
                transformFunc: (price)=>{
                    return this.resultCardService.getCurrencyFormat(price, 0);
                }
            }
        };
        const variables = Object.keys(variablesToHydrate);
        for (const variable of variables){
            const settings = variablesToHydrate[variable];
            const selector = settings.tag || this.resultCardService.toKebabCase(variable);
            const element = template.querySelector(`[data-tag-${selector}]`);
            if (settings.noValue) continue;
            let value = result[variable];
            if (settings.tagParent) element.parentElement.classList.add(settings.tagParent);
            if (settings.transformFunc) value = settings.transformFunc(value);
            if (settings.isImage) {
                element.setAttribute("src", value);
                continue;
            }
            if (settings.setTitle) element.setAttribute("title", value);
            if (settings.rating) element.parentElement.parentElement.style.setProperty("--rating", value.toString());
            element.innerText = value;
        }
    }
    setLoading(loading) {
        this.el.dataset.loading = loading.toString();
    }
}
(0, _domUtil.docReady)(()=>{
    const el = document.querySelectorAll(".xchange-public-leasing-search-results");
    if (el) el.forEach((element)=>new SearchResults(element));
});

},{"./index.css":"fW8RG","./searchResults.css":"2pCjq","./utils/resultCard.util":"hHU4l","./utils/form.utils":"cRwtA","./utils/api.utils":"6PyhB","./utils/urlParams.utils":"a0qBm","./utils/dom.util":"dQBzS"}],"fW8RG":[function() {},{}],"2pCjq":[function() {},{}],"hHU4l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResultCardService", ()=>ResultCardService);
//@ts-expect-error
const { __ } = wp?.i18n || window.wp.i18n;
class ResultCardService {
    constructor(){
        this.toKebabCase = (str)=>str.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase();
        this.getCurrencyFormat = (value, toFixed = 2)=>{
            if (isNaN(value) || value === null) return "$0";
            return `$${value.toFixed(toFixed)}`;
        };
        this.getPayee = (value)=>{
            const textArray = [
                __("User pays", "xchange-public-leasing-search-v2"),
                __("Supplier pays", "xchange-public-leasing-search-v2")
            ];
            return value === "user" ? textArray[0] : textArray[1];
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"cRwtA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormService", ()=>FormService);
const SELECTOR_CLOSE_BUTTON = "[data-item='close-button']";
const FIELDS_TO_FILL = {
    pickupLocationName: "pickup",
    dropOffLocationName: "dropoff",
    direction: "direction",
    equipmentType: "equipmenttype"
};
class FormService {
    constructor(el){
        this.el = el;
        this.closeBtn = this.el.querySelector(SELECTOR_CLOSE_BUTTON);
        this.init();
    }
    init() {
        this.fields = this.saveFieldElements();
        if (this.closeBtn) {
            this.closeBtn.addEventListener("click", ()=>{
                this.close();
            });
            this.el.addEventListener("click", (event)=>this.closeClickOutside(event));
        }
    }
    saveFieldElements() {
        const fields = {};
        Object.keys(FIELDS_TO_FILL).forEach((key)=>{
            const fieldId = FIELDS_TO_FILL[key];
            const field = this.el.querySelector(`input[type="hidden"]#${fieldId}`);
            if (field) fields[key] = field;
        });
        return fields;
    }
    fillFields(data) {
        Object.keys(this.fields).forEach((key)=>{
            const fieldValue = data[key];
            const field = this.fields[key];
            if (field && fieldValue) field.value = fieldValue;
        });
    }
    show(data) {
        if (data) {
            this.fields = this.saveFieldElements();
            this.fillFields(data);
        }
        this.el.dataset.open = "true";
    }
    close() {
        this.el.dataset.open = "false";
        this.clearData();
    }
    closeClickOutside(event) {
        if (event.target === this.el) this.close();
    }
    clearData() {
        Object.keys(this.fields).forEach((key)=>{
            const fieldElement = this.fields[key];
            fieldElement.value = "";
        });
        this.fields = {};
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6PyhB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RESULTS_PER_PAGE", ()=>RESULTS_PER_PAGE);
parcelHelpers.export(exports, "MAX_RESULTS", ()=>MAX_RESULTS);
parcelHelpers.export(exports, "ApiService", ()=>ApiService);
const URL = "https://app.container-xchange.com/api/v1/search/public";
const RESULTS_PER_PAGE = "5";
const MAX_RESULTS = "5";
class ApiService {
    constructor(options){
        this.url = URL;
        this.page = 0;
        this.resultsPerPage = options?.resultsPerPage || parseInt(RESULTS_PER_PAGE);
        this.maxResults = options?.maxResults || parseInt(MAX_RESULTS);
        this.params = "";
        this.numberOfResults = 0;
    }
    async getResults() {
        try {
            const response = await fetch(`${this.url}?${this.params}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const data = await response.json();
            this.results = this.filterNullValues(data);
            this.restrictToMaxResults();
            return this.results;
        } catch (error) {
            throw new Error(error);
        }
    }
    restrictToMaxResults() {
        if (this.results.searchResults.length > this.maxResults) this.results.searchResults = this.results.searchResults.slice(0, this.maxResults);
    }
    createSearchParams(userParams) {
        if (!userParams) return;
        Object.keys(userParams).forEach((key)=>{
            const value = userParams[key];
            if (value && value.constructor === Array && value.length === 0) delete userParams[key];
        });
        const searchParams = new URLSearchParams(userParams).toString();
        this.params = searchParams;
    }
    filterNullValues(results) {
        if (!results.searchResults) return results;
        const filteredResults = results.searchResults.filter((item)=>{
            let noNullValue = true;
            Object.keys(item).forEach((key)=>{
                if (item[key] === null) noNullValue = false;
            });
            return noNullValue;
        });
        return {
            ...results,
            searchResults: filteredResults
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a0qBm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUrlParam", ()=>getUrlParam);
parcelHelpers.export(exports, "parseUrlParams", ()=>parseUrlParams);
const getUrlParam = (key)=>{
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
};
const parseUrlParams = ()=>{
    const urlParams = new URLSearchParams(window.location.search);
    const direction = urlParams.get("direction") === "Using" ? "Using" : "Supplying";
    const pickUpLocationUnlocode = urlParams.get("pickUpLocationUnlocode")?.split(",") || [];
    const dropOffLocationUnlocode = urlParams.get("dropOffLocationUnlocode")?.split(",") || [];
    // Assign params to object and return it
    const params = {
        direction,
        pickUpLocationUnlocode,
        dropOffLocationUnlocode
    };
    return params;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dQBzS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "docReady", ()=>docReady);
function docReady(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["2yTwi"], "2yTwi", "parcelRequire94c2")

//# sourceMappingURL=searchResults.js.map
